export { MainMenuLinks } from './MainMenuLinks';
export { BurgerMenuLinks } from './BurgerMenuLinks';
export { LoginButton } from './LoginButton';

// Object with menu links
export * from './links-objects';
